import {Project} from './types';

/**
 * Why this project cannot be deleted, or `null` when it can be.
 *
 * Two rules that are really one rule — the user always keeps somewhere to put work:
 *
 * - **The last project standing stays.** Deleting it leaves every project-scoped page without
 *   context and the workspace with nothing to upload into, and there is no way back from the UI
 *   except an empty-state that the header's project switcher cannot reach.
 * - **The Default Project stays.** It is what every no-project-in-the-URL page falls back to. The
 *   count check comes first because "create another one" is the more actionable of the two, and a
 *   lone project that is also the default satisfies both.
 *
 * Deliberately not keyed off the project's name — `isDefault` is the flag (the backend sends it as
 * `is_global`).
 */
export const projectDeleteBlockedReason = (project: Project, projects: Project[]): string | null => {
  if (projects.length <= 1) {
    return 'This is your only project. Create another one before deleting it.';
  }

  if (project.isDefault) {
    return 'The Default Project is where anything you start without picking a project lands, '
      + 'so it cannot be deleted.';
  }

  return null;
};
